export enum ApiMethod {
  GET = "GET",
  POST = "POST",
  PATCH = "PATCH",
  DELETE = "DELETE",
}
//route shoude be start with "/"
export const AuthEndPoints:any= {
    GET_ADMIN_DASHBOARD: "/admin_dashboard",
    GET_USER_NOTIFICATIONS: "/user_notifications",
    MARK_USER_NOTIFICATION_READ: "/user_notifications",
    GET_ALL_USER_NOTIFICATIONS: "/user_notifications/all",
    MARK_ALL_USER_NOTIFICATIONS_READ: "/user_notifications/read-all",
    GET_ADMIN_GRID_KPIS: "/admin_dashboard/grid-kpis",
    GET_ADMIN_INSTALLED_CAPACITY_MIX: "/admin_dashboard/installed-capacity-mix",
    GET_ADMIN_DAILY_GENERATION_SOURCE_MIX: "/admin_dashboard/daily-generation-source-mix",
    GET_ADMIN_DAILY_GENERATION_OWNER_MIX: "/admin_dashboard/daily-generation-owner-mix",
    GET_ADMIN_LOAD_CURVE: "/admin_dashboard/load-curve",
    GET_ADMIN_GENERATION_TREND: "/admin_dashboard/generation-trend",
    GET_ADMIN_DAILY_ENERGY_EXCHANGE: "/admin_dashboard/daily-energy-exchange",
    GET_ADMIN_PROVINCE_LOAD_DISTRIBUTION: "/admin_dashboard/province-load-distribution",
    GET_ADMIN_TRANSMISSION_LINES_LOADING: "/admin_dashboard/transmission-lines-loading",
    GET_ADMIN_CROSSBORDER_LINE_EXCHANGE_DETAILS: "/admin_dashboard/crossborder-line-exchange-details",

    LOGIN: "/login",
    CAPTCHA: "/captcha",
    VERIFYTOKEN: "/verifytoken",
    MENU_JSON: "/menu_json",
    FORGOT_PASSWORD_MAIL: "/forgot_password_mail",
    VERIFY_FORGOT_PASSWORD_LINK: "/verify_forgot_password_link",
    UPDATE_PASSWORD: "/update_password",
    ADD_GENERATOR_UNIT: "/add_generator_unit",
    LOGOUT: "/logout",
    GET_MENUS: "/menus",
    SEARCH_MENUS: "/menus/search",
    ADD_MENU: "/addmenu",
    EDIT_MENU: "/editmenu",
    DELETE_MENU: "/deletemenu",
    GET_USERS_LIST: "/users_list",
    ADD_USER: "/add_user",
    EDIT_USER: "/edit_user",
    DELETE_USER: "/delete_user",
    UPDATE_MENU_RIGHTS: "/update_menu_rights",
    GET_MY_PROFILE: "/my_profile",
    UPLOAD_PROFILE_IMAGE: "/upload_profile_image",
    UPDATE_PROFILE_IMAGE: "/update_profile_image",
    DELETE_PROFILE_IMAGE: "/delete_profile_image",
    GET_ROLES_LIST: "/roles_list",
    ADD_ROLE: "/add_role",
    EDIT_ROLE: "/edit_role",
    DELETE_ROLE: "/delete_role",
    MANAGE_MENU_ROLEWISE: "/manage_menu_rolewise",
    GET_OUTAGE_LIST: "/outage_list",
    ADD_OUTAGE: "/add_outage",
    EDIT_OUTAGE: "/edit_outage",
    DELETE_OUTAGE: "/delete_outage",
    GET_TODAY_OUTAGE_ANALYTICS: "/today_outage",
    GET_OUTAGE_PERCENTWISE_ANALYTICS: "/outage_percentwise",
    GET_MOST_TRIPPED_OUTAGE_ANALYTICS: "/most_tripped_substations",
    GET_UPCOMING_OUTAGE_ANALYTICS: "/upcoming_outages",
    GET_LOG_SHEET_REPORT: "/logsheet_report",
    UPDATE_LOG_SHEET_CELL: "/logsheet_report/update",
    GET_LOG_SHEET_PREVIOUS_BLOCK_VALUE: "/logsheet_report/previous_block_value",
    GET_LOG_SHEET_PREVIOUS_DAY_BLOCK_VALUE: "/logsheet_report/previous_day_block_value",
    CONVERT_LOG_SHEET_DATE: "/logsheet_report/convert_date",
    GET_LOG_SHEET_BS_CALENDAR: "/logsheet_report/bs_calendar",
    EXPORT_LOG_SHEET_REPORT: "/logsheet_report/export",
    GET_PEAK_REPORT: "/peak_report",
    EXPORT_PEAK_REPORT: "/peak_report/export",
    GET_PEAK_REPORT_CHART: "/peak_report/chart",
    GET_DAILY_REPORT: "/daily_report",
    GET_ACTIVITY_LOGS: "/activity_logs",
    GET_ACTIVITY_LOG_DETAIL: "/activity_logs/detail",
    EXPORT_ACTIVITY_LOGS: "/activity_logs/export",
    DOWNLOAD_ACTIVITY_LOG_FULL: "/activity_logs/full_log",
    GET_GENERATION_DETAILS_REPORT: "/generation_details_report",
    UPDATE_GENERATION_DETAILS_CELL: "/generation_details_report/update",
    UPDATE_GENERATION_DETAILS_DAY_TOTAL: "/generation_details_report/update_day_total",
    GET_GENERATION_DETAILS_PREVIOUS_BLOCK_VALUE: "/generation_details_report/previous_block_value",
    GET_GENERATION_DETAILS_PREVIOUS_DAY_BLOCK_VALUE: "/generation_details_report/previous_day_block_value",
    EXPORT_GENERATION_DETAILS_REPORT: "/generation_details_report/export",
    GENERATION_DETAILS_TEMPLATE: "/generation_details_report/template",
    IMPORT_GENERATION_DETAILS_REPORT: "/generation_details_report/import",
    GET_DAILY_GENERATION_COMPARISON_REPORT: "/daily_generation_comparison_report",
    EXPORT_DAILY_GENERATION_COMPARISON_REPORT: "/daily_generation_comparison_report/export",
    GET_MASTER_DATA_REPORT: "/master_data_report",
    EXPORT_MASTER_DATA_REPORT: "/master_data_report/export",
      GET_READING_REPORT: "/reading_report",
      EXPORT_READING_REPORT: "/reading_report/export",
    GET_DATA_VALIDATION_REPORT: "/data_validation_report",
    GET_DATA_VALIDATION_STATS: "/data_validation_stats",
    GET_DATA_VALIDATION_VERIFICATION: "/data_validation_verification",
    GET_DATA_VALIDATION_SCADA_DETAILS: "/data_validation_scada_details",
    EXPORT_DATA_VALIDATION_SCADA_DETAILS: "/data_validation_scada_details/export",
    CONVERT_DATA_VALIDATION_DATE: "/data_validation/convert_date",

    // Manage Entity
    GET_ENTITIES_LIST: "/entities_list",
    ADD_ENTITY: "/add_entity",
    EDIT_ENTITY: "/edit_entity",
    DELETE_ENTITY: "/delete_entity",
    EXPORT_ENTITIES: "/entities_export",
    ENTITY_TEMPLATE: "/entities_template",
    IMPORT_ENTITIES: "/entities_import",
    GET_COUNTRY_DATA_STATES_LIST: "/manage_country_data/state_list",
    GET_COUNTRY_DATA_DISTRICTS_LIST: "/manage_country_data/district_list",
    GET_COUNTRY_DATA_BLOCK_LIST: "/manage_country_data/block_list",
    EDIT_COUNTRY_DATA: "/manage_country_data/edit_country_data",
    EXPORT_COUNTRY_DATA: "/manage_country_data/export",

    GET_SUBSTATIONS_LIST: "/substations_list",
    GET_TRANSMISSION_LINES_SUBSTATIONS_LIST: "/transmission_lines_substations_list",
    ADD_SUBSTATION: "/add_substation",
    EDIT_SUBSTATION: "/edit_substation",
    DELETE_SUBSTATION: "/delete_substation",
    GET_SUBSTATION_DROPDOWNS_LIST: "/substation_dropdowns_list",
    GET_SUBSTATION_GENERATORS_LIST: "/substation_generators_list",
    GET_SUBSTATION_AVAILABLE_GENERATORS_LIST: "/substation_available_generators_list",
    MAP_GENERATOR_TO_SUBSTATION: "/map_generator_to_substation",
    UNMAP_GENERATOR_FROM_SUBSTATION: "/unmap_generator_from_substation",
    EXPORT_SUBSTATIONS: "/substations_export",
    SUBSTATION_TEMPLATE: "/substations_template",
    IMPORT_SUBSTATIONS: "/substations_import",

    GET_GENERATORS_LIST: "/generators_list",
    ADD_GENERATOR: "/add_generator",
    EDIT_GENERATOR: "/edit_generator",
    DELETE_GENERATOR: "/delete_generator",
    UPLOAD_GENERATOR_FILE: "/upload_generator_file",
    EXPORT_GENERATORS: "/generators_export",
    GENERATOR_TEMPLATE: "/generators_template",
    IMPORT_GENERATORS: "/generators_import",
    GET_GENERATOR_STATES_LIST: "/generator_states_list",
    GET_GENERATOR_DISTRICTS_LIST: "/generator_districts_list",
    GET_GENERATOR_LOCAL_LEVELS_LIST: "/generator_local_levels_list",
    GET_GENERATOR_VOLTAGE_LEVELS_LIST: "/generator_voltage_levels_list",
    GET_GENERATOR_SUBSTATIONS_LIST: "/generator_substations_list",
    CREATE_GENERATOR_CONTACT_CREDENTIALS: "/generator_contact_credentials",
    GET_METERS_LIST: "/meters_list",
    GET_METER_GENERATORS: "/meter_generators_list",
    ADD_METER: "/add_meter",
    EDIT_METER: "/edit_meter",
    EXPORT_METERS: "/meters_export",
    METER_TEMPLATE: "/meters_template",
    IMPORT_METERS: "/meters_import",
    GET_GENERATOR_METERS: "/generator_meters_list",
    GET_GENERATOR_AVAILABLE_METERS: "/generator_available_meters_list",
    ASSIGN_METERS_TO_GENERATOR: "/assign_meters_to_generator",
    UNASSIGN_METER_FROM_GENERATOR: "/unassign_meter_from_generator",
    GET_API_ACCESS_TOKENS: "/api_access_tokens",
    GET_API_ACCESS_TOKEN_ENTITIES: "/api_access_token_entities",
    GENERATE_API_ACCESS_TOKEN: "/api_access_token_generate",
    ADD_API_ACCESS_TOKEN: "/api_access_tokens",
    EDIT_API_ACCESS_TOKEN: "/api_access_tokens",
    UPDATE_API_ACCESS_TOKEN_STATUS: "/api_access_tokens/status",
    EXPORT_API_ACCESS_TOKENS: "/api_access_tokens_export",

    GET_TRANSMISSION_LINES_LIST: "/transmission_lines_list",
    ADD_TRANSMISSION_LINE: "/add_transmission_line",
    EDIT_TRANSMISSION_LINE: "/edit_transmission_line",
    DELETE_TRANSMISSION_LINE: "/delete_transmission_line",
    UPLOAD_TRANSMISSION_LINE_FILE: "/upload_transmission_line_file",
    EXPORT_TRANSMISSION_LINES: "/transmission_lines_export",
    TRANSMISSION_LINE_TEMPLATE: "/transmission_lines_template",
    IMPORT_TRANSMISSION_LINES: "/transmission_lines_import",

    GET_STATES_LIST: "/states_list",
    GET_DISTRICTS_LIST: "/districts_list",
    GET_VOLTAGE_LEVELS_LIST: "/voltage_levels_list",

    GET_CONFIGURATION_PORTAL_LIST: "/configuration_portal_list",
    ADD_CONFIGURATION_VARIABLE: "/add_config_variable",
    UPDATE_CONFIGURATION_VARIABLE: "/update_config_variable",
    DELETE_CONFIGURATION_VARIABLE: "/delete_config_variable",
    GET_SCADA_CODES_LIST: "/scada_codes_list",
    EXPORT_SCADA_CODES: "/scada_codes_export",
    EDIT_SCADA_CODE: "/edit_scada_code",
    DELETE_SCADA_CODE: "/delete_scada_code",
    

}
